import type { IconData } from '@stacksjs/iconify-core'

export const friedEggBreakfastSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 1.5C10.97 1.5 1.5 13.198 1.5 27c0 10.296 6.722 19.5 15.719 19.5c3.278 0 6.296-1.226 8.776-3.273c2.225-1.837 5.197-2.693 7.965-2.693c7.221 0 12.54-7.185 12.54-15.31C46.5 13.395 38.536 1.5 24 1.5M34 22c0 5.523-4.477 10-10 10s-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10m-10-6.75a1.75 1.75 0 1 0 0 3.5A3.25 3.25 0 0 1 27.25 22a1.75 1.75 0 1 0 3.5 0A6.75 6.75 0 0 0 24 15.25\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default friedEggBreakfastSolid
